import styled, { keyframes } from 'styled-components'
import ViewImage, { ViewImageProps } from './ViewImage'
import React from 'react'

const zoomIn = keyframes`
  from {
    -webkit-transform: scale(1);
            transform: scale(1);
    -webkit-transform-origin: center center;
            transform-origin: center center;
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  10% {
    -webkit-transform: scale(1.1);
            transform: scale(1.1);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  45% {
    -webkit-transform: scale(1);
            transform: scale(1);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
`

const Image = styled.div<{
  detailedBorder?: number
  detailedPadding?: number
  width?: number
  minWidth?: number
  height?: number
  maxWidth?: number
  maxHeight?: number
  disabledPadding?: boolean
  isCursor?: boolean
  shouldContain?: boolean
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  height: ${(_: any) => (_.height ? `${_.height}px` : '100%')};
  width: ${(_: any) => (_.width ? `${_.width}px` : '100%')};
  max-height: ${(_: any) => (_.maxHeight ? `${_.maxHeight}px` : '100%')};
  min-width: ${(_: any) => (_.minWidth ? `${_.minWidth}px` : 0)};
  max-width: ${(_: any) => (_.maxWidth ? `${_.maxWidth}px` : '100%')};
  padding: ${(_: any) => (!_.disabledPadding ? `8px` : '')};
  z-index: 2;

  // border-radius: 50%;
  // -webkit-animation: ${zoomIn} 3s ease-in-out infinite both;
  // animation: ${zoomIn} 3s ease-in-out infinite both;

  & img,
  & svg {
    height: ${(_: any) => (_.detailedBorder ? `calc(100% - 10px)` : '100%')};
    width: ${(_: any) => (_.detailedBorder ? `calc(100% - 10px)` : '100%')};
    max-height: ${(_: any) => (_.maxHeight ? `${_.maxHeight}px` : '100%')};
    max-width: ${(_: any) => (_.maxWidth ? `${_.maxWidth}px` : '100%')};

    background-repeat: no-repeat;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    border: ${(_: any) =>
      _.detailedBorder ? `${_.detailedBorder}px solid #FFD730` : ''};
    padding: ${(_: any) => (_.detailedPadding ? `${_.detailedPadding}px` : '')};
    cursor: ${(_: any) => (_.isCursor ? `pointer` : undefined)};
  }
`

export interface AppImageProps extends ViewImageProps {
  imageId?: string | null
  detailedBorder?: number
  detailedPadding?: number
  width?: number
  minWidth?: number
  height?: number
  maxWidth?: number
  maxHeight?: number
  className?: string
  disabledPadding?: boolean
  isCursor?: boolean
  shouldContain?: boolean
}

const AppImage = ({
  detailedBorder,
  detailedPadding,
  width,
  height,
  maxWidth,
  minWidth,
  maxHeight,
  className,
  disabledPadding,
  isCursor,
  shouldContain,
  ...props
}: AppImageProps) => {
  return (
    <Image
      className={className}
      width={width}
      minWidth={minWidth}
      height={height}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      detailedBorder={detailedBorder}
      detailedPadding={detailedPadding}
      disabledPadding={disabledPadding}
      isCursor={isCursor}
      shouldContain={shouldContain}
    >
      <ViewImage shouldContain={shouldContain} {...props} />
    </Image>
  )
}

export default AppImage
